export const cookieTextData = {
    text: 'Продолжая пользоваться данным сайтом, вы соглашаетесь с',
    textPolicy: 'политикой обработки cookies',
    link: 'https://moskva.mts.ru/personal/cookie',
    buttonConfirm: 'OK',
    key: 'lsKeyCookieAccepted',
    value: '1',
};
